import { useEffect } from "react";
import featureFlag from "../../../lib/feature-flag/feature-flag";
import { useCurrentUserSubscriptionTier } from "../../hooks/use-current-user-subscription-tier/use-current-user-subscription-tier";
import useAccessToken from "../../hooks/useAccessToken";
import { detectUserSessionInformation } from "./utils/detect-user-session-information";

function DetectUserSession(): JSX.Element {
  const token = useAccessToken();
  const { currentUserTier, isLoading } = useCurrentUserSubscriptionTier();

  useEffect(
    function whenUserTokenChange() {
      if (isLoading) {
        return;
      }

      detectUserSessionInformation(token);
      featureFlag.updateContext(currentUserTier);
    },
    [currentUserTier, token, isLoading]
  );

  return <></>;
}

export default DetectUserSession;
